export default __webpack_public_path__ + "static/document-220215aa16cc218c9cd7d935e1498496.png";